import { Button, Tooltip } from '@nextui-org/react';
import { Icon } from '@iconify/react';

interface ExcelExportButtonProps {
  onClick: () => void;
}

const ExcelExportButton = ({ onClick }: ExcelExportButtonProps) => (
  <Tooltip content='Exportar a Excel' delay={400}>
    <Button
      size='sm'
      variant='light'
      isIconOnly
      onClick={onClick}
    >
      <Icon icon='mdi:microsoft-excel' className='text-xl text-green-600' />
    </Button>
  </Tooltip>
);

export default ExcelExportButton;
